<template>
  <ul class="infoTable">
    <li v-for="(item, index) in subscs" :key="'enable' + index">
      <em>{{item.pkg.title}}연간</em>

      <span v-if="item.state == Const.SUBSC_STATE.ENABLE_REQ">
        가입신청중: <span  :class="['confirmState', confirmStateBackColor(item.confirm) ]">{{Const.getSubscConfirmTitle()[item.confirm]}}</span><br>
        신청일자 : {{getDateFormat(item.created_at)}}
        <table v-if="item.confirm != Const.SUBSC_CONFIRM.FALSE && item.payments.termsPre.insurance"  >
          <tbody>

            <tr>
              <td>차량등록증</td>
              <td>
                <!-- :class=" { 'reUploadAtt' : (item.att_reg.options.confirm == Const.SUBSC_ATT_CONFIRM.FALSE) }"  -->
                <a 
                  :class="['reUploadAtt', reUploadAttBackColor(item.att_reg) ]"
                  @click="subscAttConfirmSubmit(item, Const.SUBSC_ATT.REG, item.att_reg)"
                >
                  {{subscAttConfirmTitle(item.att_reg)}}
                </a>
              </td>
            </tr>

            <!-- <tr v-if="item.payments.termsPre.insurance">  -->
            <tr>
              <td>정기검사결과표</td>
              <td>
                <a 
                  :class="['reUploadAtt', reUploadAttBackColor(item.att_insp)]"
                  @click="subscAttConfirmSubmit(item, Const.SUBSC_ATT.INSP, item.att_insp)"
                >
                  {{subscAttConfirmTitle(item.att_insp)}}</a>
                </td>
            </tr>

            <!-- <tr v-if="item.payments.termsPre.insurance">  -->
            <tr>
              <td>계기판</td>
              <td>
                <a 
                  :class="['reUploadAtt', reUploadAttBackColor(item.att_panel)]" 
                  @click="subscAttConfirmSubmit(item, Const.SUBSC_ATT.PANEL, item.att_panel)"
                >
                  {{subscAttConfirmTitle(item.att_panel)}}
                </a>
              </td>
            </tr>

          </tbody>
        </table>
      </span>

      <span v-else>
        <template>
          {{getDateFormat(item.date_start)}}~<br>
          {{getDateFormat(item.date_stop)}}
        </template>

        <div>
          <!-- 연장가능 구독 && 현재 연장신청한 데이터가 없을 경우 -->
          <!-- <a v-if="item.extend && availSubscExt" class="btnS" @click="emitEvent('extends', item.id, item.date_stop, item.pkg)">연장신청</a> -->
          <!-- 해지신청상태 -->
          <a v-if="item.revoke==1" class="btnS" @click="emitEvent('revoke', item.id)">해지신청중</a>
        </div>
        
      </span>

      <a class="rightArrow" @click="$router.push(`/subscStatus/subscs/${item.id}`)"></a>
    </li>
      
    <li :class="[isShowAll ? 'moreView on' : 'moreView' ]" v-if="isShowLatest">
      <button type="button" @click="isShowAll = !isShowAll">서비스 가입 내역</button>
    </li>

    <template v-if="isShowAll">
      <li v-for="(item, index) in subscs_disable" :key="'disable'+index">
        <em>{{item.pkg.title}}연간</em>
        <span>

          <template v-if="item.confirm == Const.SUBSC_CONFIRM.FALSE">
            서비스 가입 반려
          </template>

          <template v-else>
            {{getDateFormat(item.date_start)}}~<br>
            {{getDateFormat(item.date_stop)}}
          </template>
          
          <div>
            <!-- 기간만료 -->
            <a v-if="item.state == Const.SUBSC_STATE.DISABLE_EXPIRE" class="mgt1 btnS bLine">기간만료</a>
            <!-- 해지신청상태 -->
            <a v-else-if="item.revoke == 2" class="mgt1 btnS bLine">해지완료</a>
            <a v-else-if="item.revoke == 3" class="mgt1 btnS bLine">환불완료</a>
          </div>
        </span>
        <a class="rightArrow" @click="$router.push(`/subscStatus/subscs/${item.id}`)"></a>
      </li>
    </template>

    <li v-if="isShowInfo" class="mgt2">
      <a @click="$router.push('/')" class="btnL">BMW ServiceCare+ 안내</a>
    </li>
 
    <popup-alert v-if="activateEscalation && subscEscalation" 
      title="서비스 양도 안내" 
      @close="confirmEscalation">
      <div>
        <div>
          해당 차량의 BMW ServiceCare+ 서비스가 이관되었습니다.
          변경 내용은 아래와 같습니다.
        </div>

        <div class="infoTable02">
          <ul>
            <li><em>변경 전 고개</em><span>{{subscEscalation.options.escalation.name}}</span></li>
            <li><em>변경 후 고객</em><span>{{$store.state.user.name}}</span></li>
            <li><em>차대번호</em><span>{{vehicle.num_id}}</span></li>
            <li><em>차량번호</em><span>{{vehicle.num_reg}}</span></li>
            <li><em>서비스 가입일</em><span>{{subscEscalation.date_start | date}}</span></li>
            <li><em>양도일</em><span>{{subscEscalation.options.escalation.date | date}}</span></li>
            <li><em>서비스 종료일</em><span>{{subscEscalation.date_stop | date}}</span></li>
          </ul>
        </div>
       
        <div style="margin-top:10px;">위 이관 사실은 서비스 가입내역에서 확인 하실 수 있습니다.</div>
      </div>
    </popup-alert>

     <popup-picture-ex 
        v-if="picture.activate"
        btn_cancel
        :type="picture.type" 
        @close="pictureClose">
      </popup-picture-ex>
  </ul>
</template>


<script>
  import axios from "axios";
  import {api} from "@/api";
  import Const from "@/helpers/Const.js";
  import Format from "@/helpers/Format.js";

  import PopupAlert from '@/components/Popup/PopupAlert.vue';
  import PopupPictureEx from '@/components/Popup/PopupPictureEx.vue';

  
  export default {
    filters: Format,
    components:{
      PopupAlert,
      PopupPictureEx,
    },
    created() {
      this.setSubscBtn();
    },

    computed: {
      //서비스 가입내역 버튼
      isShowLatest() { 
        if(this.subscs_disable.length > 0) return true;
        else return false;
      },

      //BMW ServiceCare+ 안내 버튼
      isShowInfo() { 
        if(this.subscs.length > 0) return false;
        else return true;
      }
    },

    props: {
      items: {type: Array},
      vehicle: {type: Object},
    },

    data() {
      return {
        Const,
        availSubscExt: true,
        isShowAll: false,
        subscs: [],
        subscs_disable : [],
        subscEscalation: null,
        activateEscalation: true,

        picture: {
          activate: false,
          type: null,
          subsc: null,
        }
      };
    },

    methods: {
      confirmStateBackColor(state) { 
        let color = '';
        if(state == Const.SUBSC_CONFIRM.WAIT) color = 'backColorOrange';
        if(state == Const.SUBSC_CONFIRM.FALSE) color = 'backColorRed';
        return color;
      },
      reUploadAttBackColor(att) {
        let color = '';

        if(att && att.options && att.options.confirm) {
          if(att.options.confirm == Const.SUBSC_ATT_CONFIRM.WAIT) {
            color = 'backColorOrange';
          } 
          else if(att.options.confirm == Const.SUBSC_ATT_CONFIRM.FALSE) {
            color = 'backColorRed';
          }  
        }
        
        return color;
      },
      //이관알림 확인
      confirmEscalation() {
        if(this.subscEscalation.options.escalation.state == false){
          axios.post(`${api.subscs}/confirmEscalation/${this.subscEscalation.id}`)
        }
        this.activateEscalation = false;
      },
      // 이벤트 parents 로 전달
      emitEvent(type, subscId, dateStop, pkg) {
        const param = {
          'subsc_id': subscId,
          'date_stop': dateStop,
          'pkg': pkg,
        };
        this.$emit('popupOpen', type, param);
      },

      // 연장신청 버튼 노출 여부
      isAvailSubscExt(dateStop) {
        const remainDate = this.getSubscDateStopRemain(dateStop);
        if (remainDate <= Const.getSubscDateExtend()) return true;
        else return false;
      },

      // 연장, 해지관련 버튼 세팅
      // stateRevoke:: 0: 해지신청(해지신청가능), 1: 해지신청중(해지신청취소가능), 2: 해지완료(변경불가)
      // isAvailSubscExt:: true: 연장신청(연장신청버튼 노출), false: 연장신청 버튼 미노출
      setSubscBtn() {
        this.items.forEach((item) => {
          item.revoke = 0;
          item.extend = false;
          switch (item.state) {
            case  Const.SUBSC_STATE.DISABLE_REVOKE :    // state = -20 (해지) 일 경우 state_req 값에 따라 type 변화
              item.revoke = this.stateRevoke(item.state_req);
              break;
            // case STATE.NONE :          // state = 10 or 20 인 경우 (구독없음, 구독중) -> 구독없음일땐 연장신청 버튼 x(해당 구독이 연장신청한 구독)
            case  Const.SUBSC_STATE.ENABLE :        // state_req = 10 이면 해지신청 버튼 노출(skip) / 구독중인 경우엔 해지신청 버튼 항상 노출
              item.extend = this.isAvailSubscExt(item.date_stop); // 잔여일 30일 이하 일 경우 연장신청 버튼 노출
              break;
            case  Const.SUBSC_STATE.DISABLE_REVOKE_REFUND :   // state = -50 인 경우
            case  Const.SUBSC_STATE.DISABLE_REVOKE_REFUND_CONFIRM :   // state = -60 인 경우
              item.revoke = 3;
              break;  // state_req = 10 이면 해지완료(환불완료) (skip-> 정상동작 시 -50이면서 req가 있을 수 없음)
          }
        })
        this.setSubscItem(false);  
      },

      // 구독내역 출력 (전체/ 최신 1건)   20.03.18    sang
      setSubscItem(showAll) {
        this.availSubscExt = true; //연장신청 가능
        this.isShowAll = showAll; // 서비스 가입내역 보기
        this.subscs = []; 
        this.subscs_disable  = [];
        this.subscEscalation = null; // 이관신청 정보 

        // 현재 구독중인 데이터의 경우 해지완료보다 앞에 위치해야 함  20.04.07
        // 현재 구독 진행중인 내역이 있으면 "BMW ServiceCare+ 안내" 버튼미표기   20.03.23    sang
        this.items.forEach((subsc) => {
          if( 
            (typeof subsc.options.is_escalation != 'undefined') &&
            (typeof subsc.options.escalation != 'undefined') &&  
            subsc.options.escalation.state == false &&
            subsc.options.is_escalation &&
            this.subscEscalation == null  
          ){
            this.subscEscalation = subsc;
          }

          //구독중 or 해지신청중
          if(
            subsc.state == Const.SUBSC_STATE.ENABLE_REQ ||
            subsc.state == Const.SUBSC_STATE.ENABLE || 
            subsc.state_req ==  Const.SUBSC_STATE_REQ.DISABLE_REVOKE
          ){
            this.subscs.push(subsc);          
          }
          //구독없음 and 연장신청
          else if(subsc.state == Const.SUBSC_STATE.NONE && subsc.state_req == Const.SUBSC_STATE_REQ.ENABLE_EXT){
            this.availSubscExt = false; //연장신청 불가능
            this.subscs.unshift(subsc);
          } else {
            this.subscs_disable.push(subsc);
          }

        })
      },

      // 해지진행상태 0: 해지신청 가능(현재 함수에서는 미해당) 1: 해지신청중(해지신청취소가능), 2: 해지완료
      stateRevoke(stateReq) {
        switch (stateReq) {
          case Const.SUBSC_STATE_REQ.DISABLE_REVOKE :    // state_req = -20 이면 해지신청중(취소가능)
            return 1;
          case Const.SUBSC_STATE_REQ.DISABLE_REVOKE_CONFIRM : // state_req = -40 이면 해지완료
          case Const.SUBSC_STATE_REQ.DISABLE_REVOKE_REFUND : // state_req = -50 이면 해지완료(admin 환불신청상태)
            return 2;
        }
      },


      subscAttConfirmTitle(att) {

        if(att && att.options && att.options.confirm) {
          return Const.getSubscAttConfirmTitle()[att.options.confirm];
        } else {
          return Const.getSubscAttConfirmTitle()[Const.SUBSC_ATT_CONFIRM.FALSE];
        }
      },

      subscAttConfirmSubmit(subsc, type, att) {

        if(
          subsc.state != Const.SUBSC_STATE.ENABLE_REQ || // 서비스 가입신청중 상태
          subsc.confirm != Const.SUBSC_CONFIRM.WAIT ||   // 서비스 검수대기 상태
          (                                              // 보증상품이 없는 서비스는 계기판 결과표가 불필요
            !subsc.payments.termsPre.insurance && 
            [Const.SUBSC_ATT.INSP, Const.SUBSC_ATT.PANEL].includes(type) 
          )
        ) return;

        // 서비스가 승인대기 상태이고 파일이 없거나 부적합 상태일 경우
        if( !att || att.options.confirm == Const.SUBSC_ATT_CONFIRM.FALSE ) 
        {
          this.picture.type = type;
          this.picture.subsc = subsc;
          this.picture.activate = true;
        }
      },

      pictureClose(value) {
        this.picture.activate = false;
        if(value) this.$emit('takePicture', this.picture.type, this.picture.subsc);
        this.picture.type = null;
        this.picture.subsc = null;
      }

    },
    
    watch: {
      //차량 변경 -> 가입된 구독 재설정
      items() {
        this.setSubscBtn();
      },
    },
  };
</script>

<style scoped>
.confirmState {
  background-color: #1C69D4;
  color: #fff;
  padding: 2px 7px;
  font-size: 12px;
  border-radius: 5px;
}

.reUploadAtt {
  background-color: #1C69D4;
  color: #fff;
  padding: 2px 7px;
  font-size: 12px;
  border-radius: 5px;
}
</style>
